/* Margaret's Amber – cart drawer tweaks. 28-10-2026
   Shortens Shopify discount titles on cart lines ("Clearance: any 2 items 25% OFF (-$11.99)" -> "25% OFF"). */
(function () {
  'use strict';
  function tidy() {
    var els = document.querySelectorAll('#JdCart .jd-item__discount');
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      if (el.getAttribute('data-ma-done')) continue;
      var m = (el.textContent || '').match(/(\d+)\s*%\s*OFF/i);
      if (!m) continue;
      var svg = el.querySelector('svg');
      el.textContent = m[1] + '% OFF';
      if (svg) el.insertBefore(svg, el.firstChild);
      el.setAttribute('data-ma-done', '1');
    }
  }
  // Tiers 2/3/4/5 items: spread the steps evenly and keep the fill in sync (one level per product)
  function spread() {
    var box = document.querySelector('#JdCart .jd-rewards');
    var inner = document.querySelector('#JdCart [data-jd-inner]');
    if (!box || !inner) return;
    var steps = box.querySelectorAll('.jd-rewards__step');
    var labels = box.querySelectorAll('.jd-rewards__label');
    var n = steps.length;
    if (!n) return;
    for (var i = 0; i < n; i++) {
      var pos = ((i + 1) / n * 100).toFixed(2) + '%';
      if (steps[i].style.left !== pos) steps[i].style.left = pos;
      if (labels[i] && labels[i].style.left !== pos) labels[i].style.left = pos;
    }
    var c = parseInt(inner.getAttribute('data-real-count'), 10) || 0;
    var first = 2, seg = 100 / n, w;
    if (c < first) w = c / first * seg;
    else w = Math.min(100, seg * (c - first + 1));
    var fill = box.querySelector('.jd-rewards__fill');
    var wv = w.toFixed(2) + '%';
    if (fill && fill.style.width !== wv) fill.style.width = wv;
  }
  // "Add more, save more": show 3 cards per page, arrows flip pages
  var PER = 3;
  function pageUpsell() {
    var track = document.querySelector('#JdCart .jd-upsell__track');
    if (!track) return;
    var cards = track.querySelectorAll('.jd-up');
    var pages = Math.max(1, Math.ceil(cards.length / PER));
    var p = parseInt(track.getAttribute('data-ma-page'), 10) || 0;
    if (p >= pages) p = 0;
    for (var i = 0; i < cards.length; i++) {
      var hide = Math.floor(i / PER) !== p;
      if (cards[i].classList.contains('ma-hide') !== hide) cards[i].classList.toggle('ma-hide', hide);
    }
    var nav = document.querySelector('#JdCart .jd-upsell__nav');
    var d = pages > 1 ? '' : 'none';
    if (nav && nav.style.display !== d) nav.style.display = d;
  }
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('#JdCart .jd-upsell [data-jd-scroll-by]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    var track = document.querySelector('#JdCart .jd-upsell__track');
    if (!track) return;
    var pages = Math.max(1, Math.ceil(track.querySelectorAll('.jd-up').length / PER));
    var p = (parseInt(track.getAttribute('data-ma-page'), 10) || 0) + parseInt(btn.getAttribute('data-jd-scroll-by'), 10);
    track.setAttribute('data-ma-page', String((p + pages) % pages));
    pageUpsell();
  }, true);
  // Vera wording: "You're 1 product away from 25% discount!" / "45% Discount unlocked!"
  function words() {
    var t = document.querySelector('#JdCart .jd-rewards__text');
    if (!t) return;
    var h = t.innerHTML;
    var n = h.replace(/<b>(\d+)% OFF<\/b>/g, function (m, p) {
      return /unlocked/i.test(h) ? '<b>' + p + '% Discount</b>' : '<b>' + p + '% discount</b>';
    });
    if (n !== h) t.innerHTML = n;
  }
  // Warranty add-on: never shown as a product line, only its price counts in the total.
  // The cart title shows the number of real products (without the warranty).
  var CSS = '#JdCart .jd-item--addon{display:none!important}' +
    '#JdCart .jd-switch input:checked+.jd-switch__track{background:#303030!important}' +
    '#JdCart .jd-switch__track::after{background:#fff!important}' +
    '#JdCart .jd-addon{row-gap:0!important}#JdCart .jd-addon__desc{margin-top:5px!important}' +
    // Calm like Vera: black/grey everywhere; Margaret's Amber copper #B87333 only on banner, prices and shield; USD line black like the checkout button; cream #FBF7F0 upsell
    "#JdCart .ma-ship-banner{background:#B87333;color:#fff}#JdCart .jd-item__price,#JdCart .jd-up__price{color:#B87333}#JdCart .jd-upsell{background:#FBF7F0}#JdCart .jd-text,#JdCart .jd-text p{color:#000!important}#JdCart .jd-addon::before{background-image:url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 26'%3E%3Cpath fill='%23B87333' d='M12 1 2 4.6v7.2c0 6 4.3 11.4 10 13.2 5.7-1.8 10-7.2 10-13.2V4.6z'/%3E%3Cpath fill='%23fff' d='M12 3.3 4 6.2v5.6c0 4.9 3.4 9.3 8 10.9 4.6-1.6 8-6 8-10.9V6.2z'/%3E%3Ccircle cx='12' cy='12.4' r='5.4' fill='none' stroke='%23B87333' stroke-width='1.6'/%3E%3Cpath d='m9.6 12.5 1.7 1.7 3.2-3.4' fill='none' stroke='%23B87333' stroke-width='1.7' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E\")}";
  function injectCss() {
    if (document.getElementById('ma-cart-fix')) return;
    var st = document.createElement('style');
    st.id = 'ma-cart-fix';
    st.textContent = CSS;
    // appended at the end of <body> so it comes after ma-cart.css and wins on equal specificity
    document.body.appendChild(st);
  }
  function counts() {
    var inner = document.querySelector('#JdCart [data-jd-inner]');
    if (!inner) return;
    var real = inner.getAttribute('data-real-count');
    if (real === null) return;
    var title = document.querySelector('#JdCart .jd-cart__title');
    if (title) {
      var nt = title.textContent.replace(/\d+/, real);
      if (nt !== title.textContent) title.textContent = nt;
    }
    var bubbles = document.querySelectorAll('[data-cart-count]');
    for (var i = 0; i < bubbles.length; i++) {
      if (bubbles[i].textContent.trim() !== real) bubbles[i].textContent = real;
      if (real === '0') bubbles[i].setAttribute('hidden', ''); else bubbles[i].removeAttribute('hidden');
    }
  }
  function run() { injectCss(); tidy(); spread(); words(); counts(); pageUpsell(); }
  function start() {
    run();
    document.addEventListener('jd-cart:rendered', run);
    document.addEventListener('jd-cart:open', run);
    var root = document.getElementById('JdCart');
    if (root) new MutationObserver(run).observe(root, { childList: true, subtree: true, attributes: true, attributeFilter: ['style', 'data-real-count'] });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
